import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
// @mui/icons-material
import MenuIcon from '@mui/icons-material/Menu';
// core components
import AdminNavbarLinks from './AdminNavbarLinks';
// AWS Amplify
import { AmplifySignOut } from '@aws-amplify/ui-react';

interface Props {
  routes?: any[];
  location?: any; 
  handleDrawerToggle?: () => void;
  rtlActive?: boolean;
}

const Header = (props: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  function makeBrand() {
    let name = '';
    if (props.routes) {
      props.routes.forEach((prop: any) => {
        if (prop.layout + prop.path === props.location?.pathname) {
          name = props.rtlActive ? prop.rtlName : prop.name;
        }
      });
    }
    return name;
  }
  
  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <Typography variant="h6" component="div">
            {makeBrand()}
          </Typography>
        </Box>
        
        {!isMobile && <AdminNavbarLinks />}
        
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
            edge="end"
          >
            <MenuIcon />
          </IconButton>
        )}
        
        <Box sx={{ ml: 2 }}>
          <AmplifySignOut button-text="Logout"></AmplifySignOut>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
